import QuestionnaireContainer from './questionnaire_container';

const Questionnaire = QuestionnaireContainer;
export default Questionnaire;
